"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const TelemetryEvent_1 = require("@videoblocks/events-ts/lib/storyblocks/telemetry/TelemetryEvent");
const EventFactory_1 = require("@videoblocks/events-ts/lib/util/EventFactory");
const TelemetryTypeEnum_1 = require("@videoblocks/events-ts/lib/storyblocks/telemetry/TelemetryTypeEnum");
const User_1 = require("@videoblocks/events-ts/lib/storyblocks/common/User");
class Telemetry {
    constructor(client, user, trace) {
        this.client = client;
        this.user = user;
        this.trace = trace;
    }
    static init(client, user, trace) {
        this.instance = new Telemetry(client, user, trace);
    }
    /**
     * Use to mute Telemetry (in dev environments)
     *
     * Once muted, calls to the Telemetry instance will resolve immediately without publishing events
     */
    static mute() {
        this.instance = new Proxy(this.instance, {
            get: (target, prop, receiver) => {
                if (prop === "produceEvent") {
                    return () => Promise.resolve();
                }
                return Reflect.get(target, prop, receiver);
            }
        });
    }
    static destroy() {
        delete this.instance;
    }
    /**
     * Increment the number of occurrences for a tag.
     */
    static increment(tag) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getInstance().increment(tag);
        });
    }
    /**
     * Track a number (integer or float) value for a tag. For example, CPU load, purchase price, number of results, etc.
     */
    static gauge(tag, value) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getInstance().gauge(tag, value);
        });
    }
    /**
     * Starts a timer for a particular tag, returns a function which stops the timer
     * and sends the elapsed time (in milliseconds) to the telemetry system when called
     *
     * Each timer is completely independent; multiple timers for the same tag can be used simultaneously
     * After timer is stopped by calling the returned function, ignore subsequent calls and log a warning
     */
    static timer(tag) {
        return this.getInstance().timer(tag);
    }
    increment(tag) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.produceEvent(TelemetryTypeEnum_1.TelemetryType.INCREMENT, this.normalizeTag(tag));
        });
    }
    gauge(tag, value) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.produceEvent(TelemetryTypeEnum_1.TelemetryType.GAUGE, this.normalizeTag(tag), value);
        });
    }
    timer(tag) {
        const startMilliseconds = Date.now();
        let hasBeenStopped = false;
        return () => __awaiter(this, void 0, void 0, function* () {
            if (!hasBeenStopped) {
                const elapsedMilliseconds = Date.now() - startMilliseconds;
                hasBeenStopped = true;
                return this.produceEvent(TelemetryTypeEnum_1.TelemetryType.TIMER, tag, elapsedMilliseconds);
            }
            else {
                console.warn(`Ignoring attempt to send telemetry timer "${tag}" (started at ${startMilliseconds}) more than once`);
            }
        });
    }
    normalizeTag(tag) {
        return tag
            .toLowerCase()
            .replace(/[\t\s\n]/g, "_")
            .replace(/["'`]/g, "");
    }
    produceEvent(type, tag, value) {
        const telemetry = new TelemetryEvent_1.TelemetryEvent();
        telemetry.type = type;
        telemetry.tag = tag;
        telemetry.value = value || null;
        telemetry.meta = EventFactory_1.EventFactory.meta(this.client.getOrigin(), this.getTrace());
        telemetry.user = this.getUser();
        return this.client.produce(telemetry);
    }
    getUser() {
        const user = new User_1.User();
        user.visitorCookieId = this.user.visitorCookieId || null;
        user.subscriptionId = this.user.subscriptionId || null;
        user.userId = this.user.userId || null;
        user.organizationId = this.user.organizationId || null;
        return user;
    }
    getTrace() {
        return this.trace;
    }
    static getInstance() {
        if (!this.instance) {
            throw new Error("Must initialize Telemetry with Telemetry.init()");
        }
        return this.instance;
    }
}
exports.default = Telemetry;
//# sourceMappingURL=Telemetry.js.map